import { render } from "./MemberDashboardMobile.vue?vue&type=template&id=5cf98cba&scoped=true"
import script from "./MemberDashboardMobile.vue?vue&type=script&lang=js"
export * from "./MemberDashboardMobile.vue?vue&type=script&lang=js"

import "./MemberDashboardMobile.vue?vue&type=style&index=0&id=5cf98cba&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf98cba"]])

export default __exports__